// extracted by mini-css-extract-plugin
export default {"featured-icon":"featured-icon_featured-icon__tFXda"};